/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAPIHandler from "../../../hook/use-api-handler";


const useOwnershipDetailsService=()=>{
    const { fetchData } = useAPIHandler()
    const[ownerShipDetails,setOwnerShipDetails]=useState([]);
 
    const navigate=useNavigate();
    const fetchOrgDetailsData=async()=>{
        try{
            const response=await fetchData({
                url:'organization/get-ownership',
                method:'GET'
            });
          

            if(!response || 
                !response?.data?.ownerships?.length){
                    navigate("/organization/ownership")
            }
            setOwnerShipDetails(response?.data?.ownerships)

        }catch(error){
         
        }
    }
    useEffect(()=>{
        fetchOrgDetailsData()
    },[])
    return{
        fetchOrgDetailsData,
        ownerShipDetails
    }
}
export default useOwnershipDetailsService